module.exports = __webpack_public_path__ + "static/media/pencil.3cf2a633.svg";